import styled from '@emotion/styled';

// Note that we can't use the regular InvisibleInput, because display: none
// causes the color picker to be positioned incorrectly
const InvisibleInput = styled('input')({
  padding: 0,
  width: 0,
  height: 0,
  visibility: 'hidden',
  border: 'none',
});

export default InvisibleInput;
